import React, { Fragment } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useGetAllCards } from '../../hooks/apolloHooks/useGetAllCards'
import { BreadCrumbsIcon } from '../svgs/ExpressonSVGs'

type Props = {
	disable?: boolean
}

const Breadcrumbs: React.FC<Props> = ({ disable }) => {
	const { cards } = useGetAllCards()

	const getInvoiceStatementNames = (): string => {
		// Get unique card types from all cards
		const cardTypes = new Set(cards.map(card => card.type.shortName))
		
		// Check which card types customer has
		const hasP = cardTypes.has('P')  // Smartkort
		const hasK = cardTypes.has('K')  // Tankkort/Företagskort
		
		// Return appropriate label based on card types
		if (hasP && hasK) {
			return 'Fakturor och kontobesked'
		} else if (hasP) {
			return 'Kontobesked'
		} else if (hasK) {
			return 'Fakturor'
		}
		
		// Fallback if no cards found
		return 'Fakturor och kontobesked'
	}
	const location = useLocation()
	const pathnames = location.pathname.split('/').filter((x) => x)
	const pathNamesMapping: { [key: string]: string } = {
		'transaktioner': 'Mina köp',
		'kort': 'Hantera kort',
		'mitt-konto': 'Mitt Konto',
		'hantera-anvandare': 'Användare',
		'avsluta-konto': 'Avsluta konto',
		'kontakt': 'Kundservice',
		'nyttkort': 'Kort - Beställ nytt kort',
		'tankkort': 'Mina köp - Tankkort',
		'smartkort': 'Mina köp - Smartkort',
		'bankcard': 'Mina köp - Bankkort',
		'installningar': 'Inställningar',
		'fakturor-kontobesked': getInvoiceStatementNames()
	}

	// Add names here to disable clickable links for specific breadcrumb items
	const pathNamesLink: { [key: string]: boolean } = {
		'link-name': false,
		'mitt-konto': false
	}

	return (
	<div className="breadcrumbs" aria-label="Breadcrumb">
		<div className="Section">
			<div className="Row">
				<nav
				className="breadcrumbs__nav"
				aria-label="Breadcrumb navigation"
				role="Navigation"
				>
				<ul>
					<li key="Dashboard">
						<BreadCrumbsIcon width={20} height={20} />
						<Link
							to="/mitt-konto/dashboard"
							className={
							pathnames.includes('dashboard') ? '' : 'not-active'
							}
							aria-current="page"
						>
							Översikt
						</Link>
					</li>
					{pathnames.includes('dashboard') === false &&
					pathnames.map((name, index) => {
						const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`
						return (
							<Fragment key={`fragment-${name}-${index}`}>
							<li>{'/'}</li>
							<li key={name}>
								{typeof pathNamesLink[name] === 'boolean' && (
								<span>
									{typeof pathNamesMapping[name] === 'string'
									? pathNamesMapping[name]
									: name.charAt(0).toUpperCase() + name.slice(1)}
								</span>
								)}
								{typeof pathNamesLink[name] !== 'boolean' && (
								<Link
									aria-label={`Breadcrumb länk: ${pathNamesMapping[name]}`}
									to={routeTo}
									className={
									pathnames.length - 1 !== index
										? 'not-active'
										: ''
									}
								>
									{typeof pathNamesMapping[name] === 'string'
									? pathNamesMapping[name]
									: name.charAt(0).toUpperCase() + name.slice(1)}
								</Link>
								)}
							</li>
							</Fragment>
						)
					})}
				</ul>
				</nav>
			</div>
		</div>
	</div>
	)
}

export default Breadcrumbs
